<template>
  <div
    class="pagination"
  >
    <ul
      v-if="pagiitems"
      class="page_list"
    >
      <li>
        <nuxt-link
          :to="getUrl(1)"
          class="page_btn page_prev"
          :class="pagiitems.current_page === 1 ? 'disabled' : ''"
          aria-label="Prevent page"
        >
          <i class="icon" />
        </nuxt-link>
      </li>

      <li v-for="item in betweenPages" :key="item.key">
        <nuxt-link
          :to="getUrl(item)"
          class="page_number link_blue"
          :class="item === pagiitems.current_page ? 'active' : ''"
        >
          {{ item }}
        </nuxt-link>
      </li>

      <li>
        <nuxt-link
          :to="getUrl(pagiitems.last_page)"
          class="page_btn page_next"
          :class="pagiitems.current_page === pagiitems.last_page ? 'disabled' : ''"
          aria-label="Next page"
        >
          <i class="icon" />
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    pagiitems: {
      type: Object,
      default: null
    }
  },
  computed: {
    betweenPages () {
      const list = []
      const min = (this.pagiitems.current_page > 2) ? (this.pagiitems.current_page - 2) : 1
      const max = ((this.pagiitems.last_page - this.pagiitems.current_page) > 2) ? (this.pagiitems.current_page + 2) : this.pagiitems.last_page
      for (let i = min; i <= max; i++) {
        list.push(i)
      }
      return list
    }
  },
  methods: {
    getUrl (callPage) {
      const query = {
        ...this.$nuxt.$route.query
      }
      if (callPage === 1) {
        delete query.page
      } else {
        query.page = callPage
      }
      return { path: this.$route.path, query }
    },
    getMaxPage (numberTo, numberLast) {
      return (numberTo > numberLast) ? numberLast : numberTo
    }
  }
}
</script>
